import 'jquery-ui/ui/widgets/autocomplete';

export default class ProductElement {
  constructor(options) {
    this.templates = {
      "add_product": "<a id='add-build-product' class='button secondary editor-add-product' href=''><i class='fa fa-shopping-bag'></i> Product</a>",
      "product_editor":  "<div class='row-fluid editor-add-product-wrapper'>" +
                          "<label for='product-search'>Search for a product name or PID</label>" +
                          "<input class='build-input editor-add-product-search span12' style='display=block;'>" +
                          "<div class='editor-buttons'>" +
                            "<span class='delete'></span>" +
                            "<button class='editor-add-product-cancel cancel'>Cancel</button>" +
                            "<button class='editor-add-product-submit save'>Save</button>" +
                          "</div>" +
                          "<div class='clearfix'></div>" +
                        "</div>",
      "product_element":  "<div class='element product-element build-product'>" +
                            "<span class='build-product-hover'>"+
                              "<a href='#' class='editor-delete-build-product'>delete</a>" +
                              "<div class='clear'></div>" +
                            "</span>" +
                            "<div class='product-image'>" +
                              "<img class='img-responsive image-preview product-asset' src='' alt='' />" +
                            "</div>" +
                            "<div class='product-column product-details-wrapper'>" +
                              "<div class='product-details'>" +
                                "<h3 class='product-title'></h3>" +
                                "<div class='product-id'></div>" +
                                "<div class='product-description'></div>" +
                              "</div>" +
                            "</div>" +
                            "<div class='clearfix'></div>" +
                          "</div>"
    }

    this.options = options;

    this.learnEditor = options.editor ? options.editor : null;

    this.editor_enabled = false;
    this.activeElementId;
    this.activePosition;

    const ua = navigator.userAgent,
      action = (ua.match(/iPad/i)) ? "touchstart" : "click";

    $(document).on(action, '.add-build-product', this.append_product.bind(this));
    $(document).on(action, '.build-product', this.edit_existing_product.bind(this));
    $(document).on(action, '.editor-delete-build-product', this.delete_product_handler.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-product" href="#"><i class="fa fa-shopping-bag"></i>Product</a>';
  }

  append_product(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $element = $(event.target).closest('.button-bar, .bottom-button-bar');

    $element.hide();
    var $product_editor = $(this.templates.product_editor).hide();
    $element.replaceWith($product_editor);
    $product_editor.show();

    this.learnEditor.center_in_view($product_editor);
    this.learnEditor.editing();
    this.enable_product_editor();
  }


  edit_existing_product(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.activeElementId = $(this).attr('id');
    this.activePosition = $(this).data('position');
  }

  enable_product_editor() {
    $(document).on('click', '.editor-add-product-cancel', $.proxy(this.cancel_product_handler, this));
    this.search_product_handler();
  }

  cancel_product_handler(event) {
    event.preventDefault();
    $('.editor-add-product-wrapper').remove();

    this.learnEditor.finishEditing();
  }

  delete_product_handler(event) {
    event.preventDefault();

    this.activeElementId = "";
    this.activePosition = "";
    $(event.currentTarget).closest('.build-product').remove();

    this.learnEditor.save_page("Before Product Delete");
  }

  search_product_handler(event) {
    var that = this;
    $( ".editor-add-product-search" ).autocomplete({
      source: function(request, callback) {
        if ($('input[name="page_type"]').val() === 'user') {
          var requestUrl = "/api/products/search";
        } else {
          var requestUrl = "/admin/products/search";
        };

        $.getJSON(requestUrl, { q: request.term }, function(data) {

          for(var i=data.length-1; i>=0; i--) {
            if (!data[i].title) {
              data.splice(i, 1);
            }
          }
          callback(data);
        });
      },
      minLength: 2,
      search: function( event, ui ) {
        $(".admin-products-search").autocomplete({ position: { my : "right top", at: "right bottom" }});
      },
      select: function( event, ui ) {
        that.create_product_element(ui.item);
      },
      open: function(event, ui) {
        $("ul.ui-autocomplete.ui-menu .ui-menu-item:odd").css("background-color","#f1f1f1");
      }
    }).autocomplete("instance")._renderItem = function( ul, item ) {

      var guide_id = $('#page-editor').attr('class');
      if (guide_id) {
        guide_id = parseInt(guide_id, 10);
      }
      var url = "/admin/guides/" + guide_id + "/guides_products";
      item["url"] = url;
      if (!item.title) {
        return;
      }

      var product_listing = $( "<li></li>" ).data( "item.autocomplete", item );
      if (item.is_video) {
        product_listing.append("<img src='" + item.media_link + ".jpg'>");
      } else {
        product_listing.append("<img src='" + item.img_src + "'>");
      }

      product_listing.append( "<a class='add-product' >" + item.title + "</a>" )
      product_listing.appendTo( ul );
      return product_listing;
    };
    $(".admin-products-search-form").on('submit', function(event) {
      event.preventDefault();
    });
  }

  create_product_element(product) {
    var $product_element = $(this.templates.product_element).attr('id', (this.activeElementId || "")).data('position', this.activePosition);
    this.activeElementId = "";
    this.activePosition = "";

    $product_element.attr('data-product-id', product.id);
    $('.product-title', $product_element).text(product.title);
    $('.product-description', $product_element).text(product.description);

    var $img = $('.product-image img', $product_element);
    $img.attr('src', product.img_src);
    $img.attr('alt', product.title);


    $('.editor-add-product-wrapper').replaceWith($product_element);

    if ($product_element.prev('.build-product').length) {
      $product_element.addClass('has-sibling-product');
    }

    this.learnEditor.save_page("Before Product Modified");
  }

}
